import BlackFridayCountdown from './BlackFridayCountdown.vue';

export default BlackFridayCountdown;
